import {
  ISummaryApproverModel,
  ISummaryDraftModel,
  ISummaryFinalVersionModel,
  ISummaryGeneralInformationModel,
  ISummaryHeaderModel,
  ISummaryReviewModel,
  ISummaryReviewerModel,
} from "../models/summary.model";
import ServiceBase from "./base.service";

export class SummaryService extends ServiceBase {
  getHeader = async (ticketNumber: string): Promise<ISummaryHeaderModel> =>
    this.get(`summary/${ticketNumber}`);

  generalInformation = async (
    publicationId: number
  ): Promise<ISummaryGeneralInformationModel> =>
    this.get(`summary/${publicationId}/generalInformation`);

  draft = async (publicationId: number): Promise<ISummaryDraftModel> =>
    this.get(`summary/${publicationId}/draft`);

  finalDraft = async (publicationId: number): Promise<ISummaryDraftModel> =>
    this.get(`summary/${publicationId}/final-draft`);

  review = async (publicationId: number): Promise<ISummaryReviewModel> =>
    this.get(`summary/${publicationId}/review`);

  legal = async (publicationId: number): Promise<ISummaryReviewerModel> =>
    this.get(`summary/${publicationId}/legal`);

  approvers = async (
    publicationId: number,
    isFinal: boolean
  ): Promise<ISummaryApproverModel[]> =>
    this.get(
      `summary/${publicationId}/${
        isFinal ? "final-version-approvers" : "draft-approvers"
      }`
    );

  deleteApprovers = async (
    publicationId: number
  ): Promise<ISummaryApproverModel[]> =>
    this.get(`summary/${publicationId}/delete-approvers`);

  finalVersion = async (
    publicationId: number
  ): Promise<ISummaryFinalVersionModel[]> =>
    this.get(`summary/${publicationId}/final-versions`);
}

const summaryService = new SummaryService();

export default summaryService;
